<template>
	<div class="leftres">
		<div>
			<div :class=" showorhide ? 'inputtop' : 'inputtops' ">
				<div v-for="(item , index) of formdata" :key="index" style="display: inline-block;">
					<Commondropdownlist ref="outselect" @remoteMethodtows="remoteMethodtows" :loading="loading"
						:options="item.options" :minrigth="item.minrigth" :maxrigth="item.maxrigth"
						:minleft="item.minleft" :maxleft="item.maxleft" :lablewith="item.lablewith"
						:inputdata="item.inputdata" :title="item.title" :fontSize="item.fontSize" :color="item.color"
						:placeholder="item.placeholder" :types="item.types" :inputtype="item.inputtype"
						:width="item.width"></Commondropdownlist>
				</div>
				<div :class=" showorhide ? 'Btngroups' : 'Btngroup' ">
					<CommonBtngroup ref="btngroup" :show="showorhide" @showclick="showclick" @hide="hide"
						@select="select" @reset="reset"></CommonBtngroup>
				</div>
				<div style="height:10px;">
				</div>
			</div>
			<div class="TableBox"
				style=" box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); margin-top: 10px; background-color: #FFFFFF;">
				<Deliveryorderlisttable :loading="false" @onRowClick="onRowClick" @DespatchExport="DespatchExport"
					:tableData="tableData" :total="total" @handleCurrentChange="handleCurrentChange"
					@handleSizeChange="handleSizeChange"></Deliveryorderlisttable>
			</div>
			<div class="TableBox"
				style="margin-top: 10px; box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1); background-color: #FFFFFF;display: initial;">
				<Deliveryorderlistbottom :tableDataDetail="tableDataDetail" :tableDataUnique="tableDataUnique"
					:dpmid="dpmid"></Deliveryorderlistbottom>
			</div>
			<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibles" @cancel="cancel" @dialogOK="dialogOK"
				:src="'../assets/icon/icon-errors.png'">
				<span
					style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要重置选中账号的密码吗？</span>
			</Dialog>
		</div>
	</div>
</template>

<script>
	import Commondropdownlist from '../../../components/common-dropdownlist.vue'
	import CommonBtngroup from '../../../components/commongroup.vue'
	import Dialog from '../../../components/dialog.vue'
	import Deliveryorderlisttable from './components/deliveryorderlisttable.vue'
	import Deliveryorderlistbottom from './components/deliveryorderlist-bottom.vue'
	import utils from '../../../common/utils'
	import {
		wmsDespatchList,
		wmsDespatchExport,
		InventoryClassList,
		CusType,
		Status,
		wmsDespatchDetail,
		wmsDespatchDetailUnique,
		HelperDPVoucherType
	} from '@/api/home'
	export default {
		components: {
			Commondropdownlist,
			CommonBtngroup,
			Dialog,
			Deliveryorderlisttable,
			Deliveryorderlistbottom
		},
		data() {
			return {
				total: 1,
				pageindex: 1,
				pageSize: 20,
				tableData: [],
				showorhide: true,
				dialogVisibles: false,
				tableDataDetail: [],
				tableDataUnique: [],
				dpmid: '',
				loading: true,
				formdata: [{
						inputdata: '',
						title: '平台/经销商',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '经销商单据号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					// {
					//   inputdata: '',
					//   title: '经销商单据号',
					//   fontSize: '14px',
					//   color: '#333333',
					//   placeholder: '请输入',
					//   types: 'text',
					//   inputtype: 'selectautocompletes',
					//   width: '170px',
					//   lablewith: '95px'
					// },
					{
						inputdata: "",
						title: "出库日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '客户名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: null,
						title: '状态',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: [{
								value: '全部',
								key: ''
							},
							{
								value: '新增',
								key: '1'
							}, {
								value: '出库完成',
								key: '2'
							},
						]
					},

					{
						inputdata: '',
						title: '产品线',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: []
					},
					{
						inputdata: "",
						title: "审核日期",
						fontSize: "14px",
						color: "#333333",
						placeholder: "请输入",
						types: "",
						inputtype: "date",
						width: "140px",
						//   lablewith: '95px'
					},
					{
						inputdata: '',
						title: '单据类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '全部',
						types: '',
						inputtype: 'select',
						width: '210px',
						lablewith: '95px',
						options: []
					},
					{
						inputdata: '',
						title: '产品型号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '产品名称',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					},
					{
						inputdata: '',
						title: '批号',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '300px',
						lablewith: '85px'
					},
					{
						inputdata: '',
						title: '终端医院',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请输入',
						types: 'text',
						inputtype: 'input',
						width: '200px',
						lablewith: '95px'
					}, {
						inputdata: '',
						title: '经销商类型',
						fontSize: '14px',
						color: '#333333',
						placeholder: '请选择',
						types: '',
						inputtype: 'select',
						width: '210px',
						options: [{
							value: '一级经销商',
							key: '1'
						}, {
							value: '二级经销商',
							key: '2'
						}, ],
						lablewith: '100px'
					},
				],
				fromdatalist: [],
				from: {
					cusName: "",
					vouCode: "",
					objName: "",
					dpDate1: "",
					dpDate2: "",
					status: null,
					invClass: "",
					voucherType: "",
					verifyTime1: "",
					verifyTime2: "",
					invAddCode: "",
					invName: "",
					batch: "",
					TerminalHPName: "",
					CusGrade: "",
				}
			}
		},
		mounted() {
			//this.wmsDespatchList()
			this.$message.warning("请填写搜索条件！");
			this.$refs.outselect[2].startTime = this.$utils.getFYearDate();
			this.cusType()
			this.HelperDPVoucherType()
			this.status()
			this.inventoryClassList()
		},
		methods: {
			// 明细
			async wmsDespatchDetail() {
				let {
					data,
					code
				} = await wmsDespatchDetail({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataDetail = data
				}
			},
			// 唯一码
			async wmsDespatchDetailUnique() {
				let {
					data,
					code
				} = await wmsDespatchDetailUnique({
					dpmid: this.dpmid
				})
				if (code == 0) {
					this.tableDataUnique = data
				}
			},
			// 列表
			async wmsDespatchList() {
				const loading = this.$loading({
					lock: true,
					text: '正在加载列表...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					data,
					code
				} = await wmsDespatchList({
					cusName: this.from.cusName,
					vouCode: this.from.vouCode,
					objName: this.from.objName,
					dpDate1: this.from.dpDate1,
					dpDate2: this.from.dpDate2,
					status: this.from.status,
					invClass: this.from.invClass,
					voucherType: this.from.voucherType,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					invAddCode: this.from.invAddCode,
					invName: this.from.invName,
					batch: this.from.batch,
					TerminalHPName: this.from.TerminalHPName,
					CusGrade: this.from.CusGrade,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				//console.log(code, data.data)
				if (code == 0) {
					this.total = data.Count
					if (data.data) {
						this.tableData = data.data
					}
					loading.close();
				} else {
					loading.close();
				}
			},
			// 经销商名称远程搜索下拉
			async remoteMethodtows(query) {
				this.loading = true
				let {
					code,
					data
				} = await CusType({
					// hpName: query
				})
				if (code == 0) {
					this.formdata[1].options = []
					let obj = {
						key: data.CusCode,
						value: data.CusType
					}
					this.formdata[1].options.push(obj)
					this.loading = false
				}
			},
			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.formdata[5].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.formdata[5].options.push(obj)
					})
				}
			},
			// 单据类型下拉
			async HelperDPVoucherType() {
				let {
					code,
					data
				} = await HelperDPVoucherType({})
				if (code == 0) {
					this.formdata[7].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[7].options.push(obj)
					})

				}

			},
			// 状态下拉
			async status() {
				let {
					code,
					data
				} = await Status({})
				if (code == 0) {
					this.formdata[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.formdata[4].options.push(obj)
					})

				}

			},
			async cusType() {
				let {
					code,
					data
				} = await CusType({
					// hpName: query
				})
				if (code == 0) {
					if (data.CusType == "") {
						this.formdata[1].selcoms = true
					}
				}
			},
			// 导出
			async wmsDespatchExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await wmsDespatchExport({
					cusName: this.from.cusName,
					vouCode: this.from.vouCode,
					objName: this.from.objName,
					dpDate1: this.from.dpDate1,
					dpDate2: this.from.dpDate2,
					status: this.from.status,
					invClass: this.from.invClass,
					voucherType: this.from.voucherType,
					verifyTime1: this.from.verifyTime1,
					verifyTime2: this.from.verifyTime2,
					invAddCode: this.from.invAddCode,
					invName: this.from.invName,
					batch: this.from.batch,
					TerminalHPName: this.from.TerminalHPName,
					CusGrade: this.from.CusGrade,
					pageSize: this.pageSize,
					pageIndex: this.pageindex
				})
				if (resexprot) {
					let date = new Date()
					utils.downloadFile(resexprot.data, "出库上报" + date.getTime(), "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close();
			},
			DespatchExport() {
				this.wmsDespatchExport()
			},
			onRowClick(val) {
				this.wmsDespatchDetail()
				this.wmsDespatchDetailUnique()
				this.dpmid = val.DPMID
			},
			reset() {
				for (let index in this.$refs.outselect) {
					if (index == 2 || index == 6) {
						this.$refs.outselect[index].startTime = ''
						this.$refs.outselect[index].endTime = ''
					} else {
						this.$refs.outselect[index].modelvalue = ''
					}
				}
			},
			cancel() {
				this.dialogVisibles = false
			},
			dialogOK() {
				this.dialogVisibles = false
			},
			select() {
				for (let item of this.formdata) {
					this.fromdatalist.push(item.inputdata)
				}
				for (let item of this.formdata) {
					this.fromdatalist.push(item.inputdata)
				}
				this.pageindex = 1
				try {
					this.from.cusName = this.$refs.outselect[0].modelvalue
					this.from.vouCode = this.$refs.outselect[1].modelvalue
					this.from.dpDate1 = this.$refs.outselect[2].startTime
					this.from.dpDate2 = this.$refs.outselect[2].endTime
					this.from.objName = this.$refs.outselect[3].modelvalue
					this.from.status = this.$refs.outselect[4].modelvalue
					this.from.invClass = this.$refs.outselect[5].modelvalue
					this.from.verifyTime1 = this.$refs.outselect[6].startTime
					this.from.verifyTime2 = this.$refs.outselect[6].endTime
					this.from.voucherType = this.$refs.outselect[7].modelvalue
					this.from.invAddCode = this.$refs.outselect[8].modelvalue
					this.from.invName = this.$refs.outselect[9].modelvalue
					this.from.batch = this.$refs.outselect[10].modelvalue
					this.from.TerminalHPName = this.$refs.outselect[11].modelvalue
					this.from.CusGrade = this.$refs.outselect[12].modelvalue
					this.wmsDespatchList()
				} catch (error) {
					this.wmsDespatchList()
				}

			},
			hide() {
				this.showorhide = false
				//console.log("askdas", this.showorhide)

			},
			showclick() {
				this.showorhide = true
			},

			handleCurrentChange(pageindex) {
				this.pageindex = pageindex
				this.wmsDespatchList()
				//console.log(pageindex, 'pageindex')

			},
			handleSizeChange(paegSzie) {
				this.pageSize = paegSzie
				this.wmsDespatchList()
			},
		}
	}
</script>

<style lang="less" scoped>
	.inputtop {
		width: 980px;
		height: 140px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 15px;
		padding-bottom: 70px;
		transition: all 0.3s;
		overflow: hidden;
	}

	.inputtops {
		width: 980px;
		height: 0px;
		box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.1);
		background-color: #ffffff;
		padding-top: 9px;
		padding-bottom: 64px;
		overflow: hidden;
		position: relative;
		transition: all 0.3s;
	}

	.Btngroup {
		display: inline-block;
		float: right;
		margin-right: 10px;
		width: 300px;
		height: 50px;
		background-color: #ffffff;
		position: relative;
		bottom: 140px;
	}

	.Btngroups {
		display: inline-block;
		float: right;
		margin-top: 5px;
		margin-right: 0px;
	}
</style>